import 'css/guest.css';
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { Reservation } from "views/guest/pages/reservation/Reservation";
import { Cart } from "views/guest/pages/cart/Cart";
import { Confirm } from "views/guest/pages/comfirm/Confirm";
import { GuestInfo } from "views/guest/pages/guestinfo/GuestInfo";
import { Complete } from "views/guest/pages/complete/Complete";
import { Service } from "views/guest/pages/service/Service";
import { useOrder } from 'views/utils/UseOrder';
import { CtxOrder } from 'views/utils/Contexts';
import { Error } from "views/guest/pages/error/Error";

export function GuestLayout(): JSX.Element{

    const order = useOrder();

    return (
        <CtxOrder.Provider value={order}>
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <Switch>
                    <Route exact path='/' component={Cart}/>
                    <Route exact path='/guest' component={Cart}/>
                    <Route exact path='/guest/service' component={Service}/>                    
                    <Route exact path='/guest/cart' component={Cart}/>
                    <Route exact path='/guest/reservation' component={Reservation}/>
                    <Route exact path='/guest/guestinfo' component={GuestInfo}/>
                    <Route exact path='/guest/confirm' component={Confirm}/>
                    <Route exact path='/guest/complete' component={Complete}/>
                    <Route><Error type="notfound_error"/></Route>
                </Switch>
            </BrowserRouter>
        </CtxOrder.Provider>
    )
}